import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminSetup.css';
import API_BASE_URL from '../../config';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GroupIcon from '@mui/icons-material/Group';
import TuneIcon from '@mui/icons-material/Tune';
import SettingsIcon from '@mui/icons-material/Settings';
import LanIcon from '@mui/icons-material/Lan';
import CellTowerIcon from '@mui/icons-material/CellTower';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { Button, MenuItem, Select, InputLabel, FormControl, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers';
import { format } from 'date-fns';

import topBoardImage from '../../assets/setup/top_board.png';
import bottomBoardImage from '../../assets/setup/lower_board.png';
import internetImage from '../../assets/setup/internet.png';
import batteryConnectionImage from '../../assets/setup/battery_connection.png';
import winRImage from '../../assets/setup/win_r.png';
import controlPanelImage from '../../assets/setup/control_panel.png';
import ethernetStatusImage from '../../assets/setup/ethernet_status.png';
import ipv4Image from '../../assets/setup/ipv4.png';
import ipAddrImage from '../../assets/setup/ipaddr.png';
import ledCenterImage from '../../assets/setup/ledcenter.png';
import findImage from '../../assets/setup/find.png';
import addNewImage from '../../assets/setup/add_new.png';
import screenTestImage from '../../assets/setup/screen_test.png';
import screenTest2Image from '../../assets/setup/screen_test2.png';
import openLedToolImage from '../../assets/setup/open_ledtool.png';
import screenEditorImage from '../../assets/setup/screen_editor.png';
import hardwareParametersImage from '../../assets/setup/hardware_parameters.png';
import wifiImage from '../../assets/setup/wifi.png';
import timeSyncImage from '../../assets/setup/time_sync.png';
import cPowerImage from '../../assets/setup/cpower.png';
import cpToolImage from '../../assets/setup/cptool.png';
import blackImage from '../../assets/setup/black.png';
import pushBlackImage from '../../assets/setup/push_black.png';
import CircularProgress from '@mui/material/CircularProgress';
import ErrorIcon from '@mui/icons-material/Error';
import SignalCellular0BarIcon from '@mui/icons-material/SignalCellular0Bar';
import SignalCellular1BarIcon from '@mui/icons-material/SignalCellular1Bar';
import SignalCellular2BarIcon from '@mui/icons-material/SignalCellular2Bar';
import SignalCellular3BarIcon from '@mui/icons-material/SignalCellular3Bar';
import SignalCellular4BarIcon from '@mui/icons-material/SignalCellular4Bar';
import SignalCellularConnectedNoInternet0BarIcon from '@mui/icons-material/SignalCellularConnectedNoInternet0Bar';


const AdminSetup = () => {
    const contentRef = useRef(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [selectedDeviceType, setSelectedDeviceType] = useState('');
    const [deviceID, setDeviceID] = useState('');
    const [deviceIP, setDeviceIP] = useState('');
    const [direction, setDirection] = useState('');
    const [description, setDescription] = useState('');
    const [selectedBatterySize, setSelectedBatterySize] = useState('');
    const [selectedSolarSize, setSelectedSolarSize] = useState('');
    const [streetAddress, setStreetAddress] = useState('');
    const [suburb, setSuburb] = useState('');
    const [state, setState] = useState('');
    const [postcode, setPostcode] = useState('');
    const [country, setCountry] = useState('');
    const [builtDate, setBuiltDate] = useState(new Date());
    const [warrantyDate, setWarrantyDate] = useState(null);
    const [servicePlanDate, setServicePlanDate] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [deviceTypes, setDeviceTypes] = useState([]);
    const [batterySizes, setBatterySizes] = useState([]);
    const [solarSizes, setSolarSizes] = useState([]);
    const [error, setError] = useState('');
    const [step3Complete, setStep3Complete] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [step4Complete, setStep4Complete] = useState(false);
    const [deviceMac, setDeviceMac] = useState('');
    const [step5Complete, setStep5Complete] = useState(false);
    const [configs, setConfigs] = useState({});
    const [step6Complete, setStep6Complete] = useState(false);
    const [ipOctets, setIpOctets] = useState(['', '', '', '']);
    const [registrationInProgress, setRegistrationInProgress] = useState(false);
    const [processSteps, setProcessSteps] = useState([]);
    const [deviceInfo, setDeviceInfo] = useState(null);
    const REGISTRATION_PROCESSES = [
        'Creating new device',
        'Registering new device to server',
        'Initializing device',
        'Turn screen brightness to the lowest setting',
        'Turn screen brightness to the highest setting',
        'Turn off screen',
        'Turn on screen',
        'Reading device versions',
        'Reading storage space',
        'Reading datetime',
        'Reading temperature',
        'Reading GPS coordinates',
        'Reading 4G signal strength',
        'Reading screen position',
        'Reading door sensor status',
        'Reading battery details'
    ];
    const [processStatuses, setProcessStatuses] = useState(
        Object.fromEntries(REGISTRATION_PROCESSES.map(process => [process, 'pending']))
    );
    const [processResponses, setProcessResponses] = useState({});

    const [isOnline, setIsOnline] = useState(false);
    const [checking, setChecking] = useState(false);
    const [checkMessage, setCheckMessage] = useState("Please complete connection check before registration.");



    const navigate = useNavigate();

    useEffect(() => {
        const fetchSetupData = async () => {
            try {
            const response = await fetch(`${API_BASE_URL}/admin/setup-data`, {
                headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setCustomers(data.customers);
                setDeviceTypes(data.deviceTypes);
                setBatterySizes(data.batterySizes);
                setSolarSizes(data.solarSizes);
                setConfigs(data.configs);
            } else if (response.status === 401) {
                navigate('/unauthorized');
            } else {
                setError('Failed to fetch setup data');
            }
            } catch (error) {
            console.error('Error:', error);
            setError('An error occurred. Please try again.');
            }
        };

        fetchSetupData();
        }, [navigate]);

        useEffect(() => {
        if (contentRef.current) {
            contentRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        }, [currentStep]);

        const handleCustomerChange = (e) => {
        setSelectedCustomer(e.target.value);
        };

        const handleDeviceTypeChange = (e) => {
        setSelectedDeviceType(e.target.value);
        };

        const handleBatterySizeChange = (e) => {
        setSelectedBatterySize(e.target.value);
        };

        const handleSolarSizeChange = (e) => {
        setSelectedSolarSize(e.target.value);
        };

        const handleServicePlanDateChange = (date) => {
        setServicePlanDate(date);
        if (warrantyDate && date > warrantyDate) {
            setWarrantyDate(date);
        }
        };

        const handleContinue = () => {
        if (currentStep < steps.length) {
            setCurrentStep(currentStep + 1);
        }
        };

        const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
        };

        const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
        };

        const handleClosePopup = () => {
        setSelectedImage(null);
        };

        const handleCheckInternet = async () => {
            setChecking(true);
            setCheckMessage("");
            try {
                const response = await fetch(`${API_BASE_URL}/admin/device-connection/${deviceID}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const data = await response.json();

                    if (data.device_id === deviceID) {
                        setIsOnline(true);
                        setCheckMessage("Device is connected to the internet.");
                    } else {
                        setIsOnline(false);
                        setCheckMessage("Device is not connected. Please check again later.");
                    }
                } else {
                    setIsOnline(false);
                    setCheckMessage("Device is not connected. Please check again later.");
                }
            } catch (error) {
                console.error('Error checking connection:', error);
                setIsOnline(false);
                setCheckMessage("Error checking connection. Try again later.");
            }
            setChecking(false);
        };

        const steps = [
            { title: 'Select Customer', description: 'Please select the customer to register the new device.', icon: <GroupIcon /> },
            { title: 'Device Configuration', description: 'Configure the device settings.', icon: <TuneIcon /> },
            { title: 'Hardware Setup', description: 'Set up the hardware components.', icon: <SettingsIcon /> },
            { title: 'Connectivity Settings', description: 'Configure the connectivity settings.', icon: <LanIcon /> },
            { title: 'Network Setup', description: 'Set up the network configurations.', icon: <CellTowerIcon /> },
            { title: 'Push Media to Device', description: 'Add media to device', icon: <DriveFileMoveIcon /> },
            { title: 'Register Device to Server', description: 'Please do not close or refresh window.', icon: <CloudUploadIcon /> },
            { title: 'Finish Up', description: 'Complete the setup process.', icon: <DoneAllIcon /> }
        ];

        const isStepComplete = () => {
            switch (currentStep) {
                case 1:
                    return selectedCustomer;
                case 2:
                    return selectedDeviceType && deviceID && deviceIP && selectedBatterySize && selectedSolarSize && streetAddress && suburb && state && postcode && country;
                case 3:
                    return step3Complete;
                case 4:
                    return step4Complete;
                case 5:
                    return deviceID && deviceMac && step5Complete;
                case 6:
                    return step6Complete;
                default:
                    return true;
            }
        };

        // Add handler for IP octet changes
        const handleIpOctetChange = (index, value) => {
        if (value === '' || (parseInt(value) >= 0 && parseInt(value) <= 255)) {
            const newOctets = [...ipOctets];
            newOctets[index] = value;
            setIpOctets(newOctets);
            setDeviceIP(newOctets.join('.'));
        }
        };

        const validateRegistration = () => {
            const requiredFields = {
            selectedCustomer,
            deviceID,
            selectedDeviceType,
            deviceMac,
            selectedBatterySize,
            selectedSolarSize,
            streetAddress,
            suburb,
            state,
            country,
            builtDate,
            warrantyDate,
            servicePlanDate
            };
        
            return Object.entries(requiredFields).every(([key, value]) => value);
        };

        const handleRegisterDevice = async () => {
            if (!validateRegistration()) {
            setError('Please fill in all required fields');
            return;
            }
        
            setRegistrationInProgress(true);
            setProcessStatuses(
            Object.fromEntries(REGISTRATION_PROCESSES.map(process => [process, 'loading']))
            );
            setProcessResponses({});
        
            try {
            const response = await fetch(`${API_BASE_URL}/admin/register-device`, {
                method: 'POST',
                headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userId: selectedCustomer,
                    deviceId: deviceID,
                    deviceTypeId: selectedDeviceType,
                    macAddr: deviceMac,
                    batterySizeId: selectedBatterySize,
                    solarSizeId: selectedSolarSize,
                    address: {
                    streetAddress,
                    suburb,
                    state,
                    country,
                    postcode
                    },
                    direction,
                    description,
                    dates: {
                        built: format(builtDate, 'yyyy-MM-dd'),
                        warranty: format(warrantyDate, 'yyyy-MM-dd'),
                        servicePlan: format(servicePlanDate, 'yyyy-MM-dd')
                    }
                })
            });
      
          const reader = response.body.getReader();
          const decoder = new TextDecoder();
      
          while (true) {
            const { value, done } = await reader.read();
            if (done) {
                setProcessStatuses(prev => 
                    Object.fromEntries(
                        Object.entries(prev).map(([key, value]) => 
                            [key, value === 'loading' ? 'error' : value]
                        )
                    )
                );
                break;
            }
            const events = decoder.decode(value).split('\n\n');
            events.forEach(event => {
              if (event.startsWith('data: ')) {
                const data = JSON.parse(event.slice(6));
                setProcessStatuses(prev => ({
                  ...prev,
                  [data.process]: data.status
                }));
                if (data.response) {
                  setProcessResponses(prev => ({
                    ...prev,
                    [data.process]: data.response
                  }));
                }
              }
            });
          }
        } catch (error) {
            console.error('Error:', error);
            setError('An unexpected error occurred');
            setProcessStatuses(prev => 
                Object.fromEntries(
                    Object.entries(prev).map(([key, value]) => 
                        [key, value === 'loading' ? 'error' : value]
                    )
                )
            );
        }
      };

      const getSignalStrength = (dBm) => {
        if (!dBm || dBm === 99) return -1;
        
        const strength = parseInt(dBm);
        if (strength >= -70) return 4;
        if (strength >= -85) return 3;
        if (strength >= -100) return 2;
        if (strength >= -110) return 1;
        return 0;
      };
      
      const getSignalIcon = (dBm) => {
        const strength = getSignalStrength(dBm);
        
        const icons = {
            0: <SignalCellular0BarIcon sx={{ color: '#ff9800' }}/>,
            1: <SignalCellular1BarIcon sx={{ color: '#ff9800' }}/>,
            2: <SignalCellular2BarIcon sx={{ color: '#4caf50' }}/>,
            3: <SignalCellular3BarIcon sx={{ color: '#4caf50' }}/>,
            4: <SignalCellular4BarIcon sx={{ color: '#4caf50' }}/>
          };
          return icons[strength] || <SignalCellularConnectedNoInternet0BarIcon sx={{ color: '#f44336' }}/>;
      };
      
      // Update process item rendering
      const renderProcessResponse = (process, response) => {
        if (!response) return null;
        if (process === 'Reading 4G signal strength') {
            const strengthValue = parseInt(response.strength);
            const signalData = getSignalStrength(strengthValue);
            
            return (
              <div className="process-response">
                <div className="response-grid">
                    <div className="response-item">
                    <span className="response-key">Signal Strength:</span>
                    <span className="response-value">
                        {getSignalIcon(strengthValue)}
                        {response.strength}
                    </span>
                    </div>
                    <div className="response-item">
                    <span className="response-key">Network Mode:</span>
                    <span className="response-value">{response.mode}</span>
                    </div>
                </div>
              </div>
            );
        }
        return (
          <div className="process-response">
            {typeof response === 'object' ? (
              <div className="response-grid">
                {Object.entries(response).map(([key, value]) => (
                  <div key={key} className="response-item">
                    <span className="response-key">{key}:</span>
                    <span className="response-value">{value}</span>
                  </div>
                ))}
              </div>
            ) : (
              <span className="response-text">{response}</span>
            )}
          </div>
        );
    };

    const handleSetupComplete = () => {
        navigate('/admin/dashboard');
    };



    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div className="admin-setup-container">
            <div className="agenda">
                <p>Complete the following steps to set up new device</p>
                <ul>
                {steps.map((step, index) => (
                    <li key={index} className={currentStep === index + 1 ? 'active' : ''}>
                    <span className="step-icon">
                        {currentStep > index + 1 ? <CheckCircleIcon style={{ color: 'green' }} /> : currentStep === index + 1 ? React.cloneElement(step.icon, { style: { color: 'green' } }) : step.icon}
                    </span>
                    <span className="step-title">{step.title}</span>
                    </li>
                ))}
                </ul>
            </div>
            <div className="setup-area" ref={contentRef}>
                <h3 className="step-count">Step {currentStep} of {steps.length}</h3>
                <h4 className="step-name">{steps[currentStep - 1].title}</h4>
                <p>{steps[currentStep - 1].description}</p>
                {currentStep === 1 && (
                <div className="step-content">
                    <FormControl fullWidth variant="outlined">
                    <InputLabel id="customer-select-label">Select Customer</InputLabel>
                    <Select
                        labelId="customer-select-label"
                        id="customer-select"
                        value={selectedCustomer}
                        onChange={handleCustomerChange}
                        label="Select Customer"
                        style={{ backgroundColor: '#fff' }}
                    >
                        {customers.map((customer) => (
                        <MenuItem key={customer.id} value={customer.id}>
                            {customer.org_name}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                    {error && <p className="error">{error}</p>}
                </div>
                )}
                {currentStep === 2 && (
                <div className="step-content">
                    <FormControl fullWidth variant="outlined" margin="normal">
                    <InputLabel id="device-type-select-label">Select Device Type</InputLabel>
                    <Select
                        labelId="device-type-select-label"
                        id="device-type-select"
                        value={selectedDeviceType}
                        onChange={handleDeviceTypeChange}
                        label="Select Device Type"
                        style={{ backgroundColor: '#fff' }}
                    >
                        {deviceTypes.map((deviceType) => (
                        <MenuItem key={deviceType.id} value={deviceType.id}>
                            {deviceType.name}
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                    <div className="custom-description">* <b>Device ID</b> and <b>IP</b> address can be found on the back of device</div>
                    <TextField
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    label="Device ID"
                    value={deviceID}
                    onChange={(e) => setDeviceID(e.target.value)}
                    InputProps={{
                        style: { color: '#fff' }
                    }}
                    />
                    IP Address: 
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {[0, 1, 2, 3].map((index) => (
                        <React.Fragment key={index}>
                        <TextField
                            style={{ width: '70px' }}
                            variant="outlined"
                            margin="normal"
                            value={ipOctets[index]}
                            onChange={(e) => handleIpOctetChange(index, e.target.value)}
                            inputProps={{
                            maxLength: 3,
                            style: { color: '#fff', textAlign: 'center' }
                            }}
                        />
                        {index < 3 && <span style={{ color: '#fff', fontSize: '20px' }}>.</span>}
                        </React.Fragment>
                    ))}
                    </div>
                    Enter the <b>battery and solar panel size</b> installed for the new device
                    <FormControl fullWidth variant="outlined" margin="normal">
                    <InputLabel id="battery-size-select-label">Select Battery Size (Ah)</InputLabel>
                    <Select
                        labelId="battery-size-select-label"
                        id="battery-size-select"
                        value={selectedBatterySize}
                        onChange={handleBatterySizeChange}
                        label="Select Battery Size (in Ah)"
                        style={{ backgroundColor: '#fff' }}
                    >
                        {batterySizes.map((batterySize) => (
                        <MenuItem key={batterySize.id} value={batterySize.id}>
                            {batterySize.capacity} Ah
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                    <FormControl fullWidth variant="outlined" margin="normal">
                    <InputLabel id="solar-size-select-label">Select Solar Panel Size (in W)</InputLabel>
                    <Select
                        labelId="solar-size-select-label"
                        id="solar-size-select"
                        value={selectedSolarSize}
                        onChange={handleSolarSizeChange}
                        label="Select Solar Panel Size (in W)"
                        style={{ backgroundColor: '#fff' }}
                    >
                        {solarSizes.map((solarSize) => (
                        <MenuItem key={solarSize.id} value={solarSize.id}>
                            {solarSize.watt} W
                        </MenuItem>
                        ))}
                    </Select>
                    </FormControl>
                    Enter <b>address</b> details for the new device
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Street Address"
                        value={streetAddress}
                        onChange={(e) => setStreetAddress(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Suburb"
                        value={suburb}
                        onChange={(e) => setSuburb(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="State"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Postcode"
                        value={postcode}
                        onChange={(e) => setPostcode(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Country"
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <FormControl fullWidth margin="normal" variant="outlined">
                        <InputLabel style={{ color: '#fff' }}>Direction</InputLabel>
                        <Select
                            label="Direction"
                            value={direction}
                            onChange={e => setDirection(e.target.value)}
                            style={{ color: '#fff' }}
                            inputProps={{ style: { color: '#fff' } }}
                            defaultValue="None"
                        >
                            <MenuItem value="None">None</MenuItem>
                            <MenuItem value="Northbound">Northbound</MenuItem>
                            <MenuItem value="Southbound">Southbound</MenuItem>
                            <MenuItem value="Eastbound">Eastbound</MenuItem>
                            <MenuItem value="Westbound">Westbound</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField
                        fullWidth
                        variant="outlined"
                        margin="normal"
                        label="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        InputProps={{
                            style: { color: '#fff' }
                        }}
                    />
                    <p className="custom-description">Warranty details </p>
                    <div className="date-picker-row">
                    <DatePicker
                        label="Built Date"
                        value={builtDate}
                        onChange={(date) => setBuiltDate(date)}
                        TextField={(params) => <TextField {...params} fullWidth variant="outlined" margin="normal" />}
                    />
                    </div>
                    <div className="date-picker-row">
                    <DatePicker
                        label="Warranty Date"
                        value={warrantyDate}
                        onChange={(date) => setWarrantyDate(date)}
                        TextField={(params) => <TextField {...params} fullWidth variant="outlined" margin="normal" />}
                    />
                    </div>
                    <div className="date-picker-row">
                    <DatePicker
                        label="Service Plan Date"
                        value={servicePlanDate}
                        onChange={handleServicePlanDateChange}
                        TextField={(params) => <TextField {...params} fullWidth variant="outlined" margin="normal" />}
                    />
                    </div>
                </div>
                )}
                {currentStep === 3 && (
                <div className="step-content">
                    <div className="instruction">
                        <img 
                            src={topBoardImage} 
                            alt="Top Board" 
                            onClick={() => handleImageClick(topBoardImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Unscrew the <b>2 screws</b> on the top board marked in red in the above image, then gently lift the board up and remove it by holding the <span style="color: #fdd835;">yellow</span> parts of the boards.`
                        }} />
                        
                        <img 
                            src={bottomBoardImage} 
                            alt="Bottom Board" 
                            onClick={() => handleImageClick(bottomBoardImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Install <b>SIM card</b> then <b>CR1220 battery</b> to the bottom board as shown in the above image. SIM card slot is located on the other side of the board behind battery.`
                        }} />
                    </div>
                    <div className="instruction">

                    </div>

                    <div className="instruction">
                    <img 
                        src={internetImage} 
                        alt="Internet" 
                        onClick={() => handleImageClick(internetImage)}
                    />
                    <div dangerouslySetInnerHTML={{
                        __html: `Connect the <b>network cable</b> to the board as shown in the above image, and connect the other end to the computer.`
                    }} />
                    
                    </div>

                    <div className="instruction">
                    <img 
                        src={batteryConnectionImage} 
                        alt="Battery Connection" 
                        onClick={() => handleImageClick(batteryConnectionImage)}
                    />
                    <div dangerouslySetInnerHTML={{
                        __html: `Connect the <b>battery power and RS485 cords</b> to the board as shown in the above image, and connect solar feed in cable on the back of the case.`
                    }} />
                    
                    <FormControlLabel
                        control={
                        <Checkbox 
                            checked={step3Complete} 
                            onChange={(e) => setStep3Complete(e.target.checked)}
                            name="controlBoardOn"
                            style={{color: 'rgba(76, 175, 80, 0.6)'}}
                        />
                        }
                        label="Hardware setup completed"
                    />
                    </div>

                    {selectedImage && (
                    <div className="image-popup" onClick={handleClosePopup}>
                        <img src={selectedImage} alt="Enlarged view" />
                    </div>
                    )}
                </div>
                )}
                {currentStep === 4 && (
                <div className="step-content">
                    <div className="instruction">
                    <img 
                        src={winRImage} 
                        alt="Win+R Dialog" 
                        onClick={() => handleImageClick(winRImage)}
                    />
                    <div dangerouslySetInnerHTML={{
                        __html: `Press <b>Win + R</b> on your keyboard to open the Run dialog box, type in <b>ncpa.cpl</b>, and hit <b>Enter</b>`
                    }} />
                    </div>

                    <div className="instruction">
                    <img 
                        src={controlPanelImage} 
                        alt="Control Panel" 
                        onClick={() => handleImageClick(controlPanelImage)}
                    />
                    <div dangerouslySetInnerHTML={{
                        __html: `Right click on <b>Ethernet</b> and select <b>Status</b>`
                    }} />
                    </div>

                    <div className="instruction">
                    <img 
                        src={ethernetStatusImage} 
                        alt="Ethernet Status" 
                        onClick={() => handleImageClick(ethernetStatusImage)}
                    />
                    <div dangerouslySetInnerHTML={{
                        __html: `Click <b>Properties</b>`
                    }} />
                    </div>

                    <div className="instruction">
                    <img 
                        src={ipv4Image} 
                        alt="IPv4 Settings" 
                        onClick={() => handleImageClick(ipv4Image)}
                    />
                    <div dangerouslySetInnerHTML={{
                        __html: `Make sure <b>IPv4 (Internet Protocol Version 4 TCP/IPv4)</b> is checked, and <b>double click</b> it.`
                    }} />
                    </div>

                    <div className="instruction">
                    <img 
                        src={ipAddrImage} 
                        alt="IP Address Configuration" 
                        onClick={() => handleImageClick(ipAddrImage)}
                    />
                    <div dangerouslySetInnerHTML={{
                            __html: `Make sure the <span style="color: fdd835"><b>IP address</b></span> is set to <span style="color: red">${deviceIP}</span>, <b>subnet mask</b> to <span style="color: red">255.255.255.0</span>, and <b>default gateway</b> to <span style="color: red">192.168.1.1</span>`
                        }} />
                    </div>
                    <div className="instruction" style={{ marginTop: '20px' }}>
                        <FormControlLabel
                            control={
                            <Checkbox 
                                checked={step4Complete}
                                onChange={(e) => setStep4Complete(e.target.checked)}
                                style={{color: 'rgba(76, 175, 80, 0.6)'}}
                            />
                            }
                            label="I have completed all the network configuration steps"
                        />
                        </div>
                    {selectedImage && (
                    <div className="image-popup" onClick={handleClosePopup}>
                        <img src={selectedImage} alt="Enlarged view" />
                    </div>
                    )}
                </div>
                )}
                {currentStep === 5 && (
                    <div className="step-content">
                        <div className="instruction">
                        <img 
                            src={ledCenterImage} 
                            alt="LED Center" 
                            onClick={() => handleImageClick(ledCenterImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Open <b>LEDCenterM</b> on the computer new device connected.`
                        }} />
                        </div>

                        <div className="instruction">
                        <img 
                            src={findImage} 
                            alt="Find Network" 
                            onClick={() => handleImageClick(findImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Click on <b>Find</b> and select <b>Network</b>.`
                        }} />
                        <img 
                            src={addNewImage} 
                            alt="Add New Device" 
                            onClick={() => handleImageClick(addNewImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Click the device, and make sure <b>card type</b> is <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.card_type}</span>, 
                            <b>color</b> = <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.color}</span>, 
                            <b>width</b> = <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.width}</span>, 
                            <b>height</b> = <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.height}</span>`
                        }} />
                        </div>
                        <div className="instruction">
                            <div dangerouslySetInnerHTML={{
                                __html: `Please enter <b>device CPID and MAC address</b> displayed on <b>LEDCenterM</b> here.`
                            }} />
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                label="Device MAC Address"
                                value={deviceMac}
                                onChange={(e) => setDeviceMac(e.target.value)}
                                InputProps={{
                                style: { color: '#fff' }
                                }}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Click <b>Define Screen</b>`
                            }} />
                            <img 
                                src={screenTestImage} 
                                alt="Screen Test" 
                                onClick={() => handleImageClick(screenTestImage)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Click on <b>Program->Window->Play</b>, select <b>Documents</b>, and select <b>screen_test.gif</b>, then click <b>Send Data.</b>`
                            }} />
                            <img 
                                src={screenTest2Image} 
                                alt="Screen Test 2" 
                                onClick={() => handleImageClick(screenTest2Image)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Select the new screen, click on <b>Send to Current</b>, make sure the screen is displaying the test image.`
                            }} />
                            <img 
                                src={openLedToolImage} 
                                alt="Open LED Tool" 
                                onClick={() => handleImageClick(openLedToolImage)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Click on <b>Define</b> on the navbar, select the currect device, and click on <b>Edit</b>, enter <b>password</b> <span style="color: red">${configs?.password1 || '16888'}</span>, then click <b>Define Screen</b>`
                            }} />
                            <img 
                                src={screenEditorImage} 
                                alt="Screen Editor" 
                                onClick={() => handleImageClick(screenEditorImage)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `<b>Select</b> 
                                model: <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.card_type}</span>,`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `
                                    Width: <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.width}</span>, 
                                    Height: <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.height}</span>, 
                                    Color: <span style="color: red">${deviceTypes.find(type => type.id === selectedDeviceType)?.color}</span>`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `Type: <span style="color: red">Network connect to the LED controller directly</span>`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `IP Address: <span style="color: red">${deviceIP}</span>,  
                                    Port: <span style="color: red">5200</span></span>,
                                    Password: <span style="color: red">ffffffff</span>`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `Then press <b>LedTool</b>`
                            }} />
                            <img 
                                src={hardwareParametersImage} 
                                alt="Hardware Parameters" 
                                onClick={() => handleImageClick(hardwareParametersImage)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Click on the lock icon, and enter <b>password</b> <span style="color: red">${configs?.password2 || '268888'}</span> to unlock, select <b>Hardware Parameters</b> tab, then click <b>Read</b>.`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `Enable <b>Modify communication parameters</b>, then enable <b>Enable server</b> under <b>Cloud server parameters</b>.`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `Enter server ID: <span style="color: red">${configs?.ip_address}</span>, port: <span style="color: red">${configs?.port}</span>,project name: <span style="color: red">${configs?.project_name}</span>, and password: <span style="color: red">${configs?.device_password}</span>.`
                            }} />
                            <img 
                                src={wifiImage} 
                                alt="wifi" 
                                onClick={() => handleImageClick(wifiImage)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Open <b>WiFi parameters</b> tab, and click <b>read</b>.`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `Set <b>SSID</b>: <span style="color: red">${deviceID}</span>, <b>Wifi channel</b>: <span style="color: red">1</span>, and <b>key</b>: <span style="color: red">${configs?.wifi_password}</span>.`
                            }} />
                            <img 
                                src={timeSyncImage} 
                                alt="Time Sync" 
                                onClick={() => handleImageClick(timeSyncImage)}
                            />
                            <div dangerouslySetInnerHTML={{
                                __html: `Click on <b>Settings->Date time</b>, select the current device, make sure the <b>Current computer time</b> is enabled, then click <b>Set to screen</b>.`
                            }} />
                        </div>
                        <div className="instruction" style={{ marginTop: '20px' }}>
                        <FormControlLabel
                            control={
                            <Checkbox 
                                checked={step5Complete}
                                onChange={(e) => setStep5Complete(e.target.checked)}
                                style={{color: 'rgba(76, 175, 80, 0.6)'}}
                            />
                            }
                            label="I have completed all the LED configuration steps"
                        />
                        </div>

                        {selectedImage && (
                        <div className="image-popup" onClick={handleClosePopup}>
                            <img src={selectedImage} alt="Enlarged view" />
                        </div>
                        )}
                    </div>
                )}
                {currentStep === 6 && (
                    <div className="step-content">
                        <div className="instruction">
                            <div dangerouslySetInnerHTML={{
                                __html: `<span style="color: fdd835;">Plug media USB key onto the control card. Screen should flash <b>USB</b> indicating transfering file, unplug the USB key when it disappears.</span>`
                            }} />
                            <div dangerouslySetInnerHTML={{
                                __html: `<br/>Or`
                            }} />
                        <img 
                            src={cPowerImage} 
                            alt="CPower Tool" 
                            onClick={() => handleImageClick(cPowerImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Open <b>CPowerTool</b>, select <b>Network</b>, and enter:
                            <br/><br/>IP Address: <span style="color: red">${deviceIP}</span>,
                            port: <span style="color: red">5200</span>
                            <br/><br/>Make sure <b>Password</b> is unselected`
                        }} />
                        <img 
                            src={cpToolImage} 
                            alt="CP Tool" 
                            onClick={() => handleImageClick(cpToolImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `<br/>Click on <b>Refresh</b> for both <b>User Disk</b> and <b>System Disk</b> to make sure the device is connected.`
                        }} />
                        <div dangerouslySetInnerHTML={{
                            __html: `<br/>Write image files to the device by clicking <b>Write File</b> button of <span style="color: red"><b>System Disk</b></span>, update <b>one image at a time</b>.`
                        }} />
                        <div dangerouslySetInnerHTML={{
                            __html: `<br/>When finished, click on <b>Exit</b> on the bottom.`
                        }} />
                        </div>

                        <div className="instruction" style={{ marginTop: '20px' }}>
                        <FormControlLabel
                            control={
                            <Checkbox 
                                checked={step6Complete}
                                onChange={(e) => setStep6Complete(e.target.checked)}
                                style={{color: 'rgba(76, 175, 80, 0.6)'}}
                            />
                            }
                            label="I have completed all media file transfers"
                        />
                        </div>

                        {selectedImage && (
                        <div className="image-popup" onClick={handleClosePopup}>
                            <img src={selectedImage} alt="Enlarged view" />
                        </div>
                        )}
                    </div>
                )}
                {currentStep === 7 && (
                    <div className="step-content">
                        <div className="register-section" style={{ textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            onClick={handleCheckInternet}
                            disabled={checking}
                            style={{
                                backgroundColor: 'rgba(33, 150, 243, 0.9)',
                                marginBottom: '10px',
                                padding: '10px 30px'
                            }}
                        >
                            {checking ? "Checking..." : "Check Internet Connection"}
                        </Button>
                        {checkMessage && (
                            <div style={{ color: isOnline ? 'green' : 'red', marginBottom: '10px' }}>{checkMessage}</div>
                        )}
                        <Button
                            variant="contained"
                            onClick={handleRegisterDevice}
                            disabled={!isOnline || registrationInProgress}
                            startIcon={<CloudUploadIcon />}
                            style={{
                                backgroundColor: 'rgba(76, 175, 80, 0.9)',
                                marginBottom: '20px',
                                padding: '10px 30px'
                            }}
                        >
                            Register Device
                        </Button>

                        <div className="process-list">
                            {REGISTRATION_PROCESSES.map((process, index) => (
                                <div key={index} className="process-item">
                                <div className="process-header">
                                    <div className="process-status">
                                    {processStatuses[process] === 'pending' && <div className="status-dot" />}
                                    {processStatuses[process] === 'loading' && <CircularProgress size={20} />}
                                    {processStatuses[process] === 'success' && <CheckCircleIcon style={{ color: 'green' }} />}
                                    {processStatuses[process] === 'error' && <ErrorIcon style={{ color: 'red' }} />}
                                    </div>
                                    <span className="process-name">{process}</span>
                                </div>
                                {renderProcessResponse(process, processResponses[process])}
                                </div>
                            ))}
                        </div>
                        </div>
                    </div>
                )}
                {currentStep === 8 && (
                    <div className="step-content">
                        <div className="instruction">
                        <img 
                            src={blackImage} 
                            alt="Black Screen Setup" 
                            onClick={() => handleImageClick(blackImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Open <b>LedCenterM</b>, click on <b>Media Play</b>, select <b>Text</b>, and remove all text, then click on <b>Send Data</b>.`
                        }} />
                        </div>

                        <div className="instruction">
                        <img 
                            src={pushBlackImage} 
                            alt="Push Black Screen" 
                            onClick={() => handleImageClick(pushBlackImage)}
                        />
                        <div dangerouslySetInnerHTML={{
                            __html: `Select the correct screen, and click on <b>Send to Current</b>, make sure the screen is displaying black.`
                        }} />
                        <div dangerouslySetInnerHTML={{
                            __html: `<b>Unplug the network cable</b> from control board.`
                        }} />
                        </div>

                        <div className="instruction" style={{ marginTop: '30px', textAlign: 'center' }}>
                        <Button
                            variant="contained"
                            onClick={handleSetupComplete}
                            style={{
                                backgroundColor: 'rgba(76, 175, 80, 0.9)',
                                color: 'white',
                                padding: '10px 20px',
                                fontSize: '16px'
                            }}
                        >
                            Device Setup Completed
                        </Button>
                        </div>

                        {selectedImage && (
                        <div className="image-popup" onClick={handleClosePopup}>
                            <img src={selectedImage} alt="Enlarged view" />
                        </div>
                        )}
                    </div>
                    )}
                                    <div className="navigation-buttons">
                <Button variant="contained" onClick={handleBack} disabled={currentStep === 1} style={{ backgroundColor: 'rgba(0, 135, 5, 0.9)' }}>
                    Back
                </Button>
                <Button variant="contained" onClick={handleContinue} disabled={!isStepComplete()} style={{ backgroundColor: 'rgba(0, 135, 5, 0.9)' }}>
                    Continue
                </Button>
                </div>
            </div>
        </div>
    </LocalizationProvider>
    );
};

export default AdminSetup;